import { Campaign } from '../types/Campaign';
import { Event } from '../types/Event';
import moment from 'moment-timezone';

export const getEmptyEventPermissions = (target: Event | Campaign): string[] => {
  const isEvent = target instanceof Event;
  const eventPermissions = isEvent ? target?.eventPermissions : target?.campaignSettings?.eventPermissions;
  return eventPermissions?.filter((item) => !item.eventPermissionType).map((item) => item.email) || [];
};

/**
 * Determines if the string is a past date. 
 * 
 * @param startDate 
 * @returns 
 */
export const isDateInThePast = (startTimestamp: number | string): boolean => {
  if(startTimestamp && moment.utc(startTimestamp).isBefore(moment.now())){
    return true;
  } else {
    return false;
  }
}

/**
 * Gets all the challenge IDs in the event, including backup challenges
 * 
 * @param target 
 * @returns string[]
 */
export const getAllChallengeIdsFromEvent = (target: Event | Campaign) => {
  if (!target.challengeDescriptors || !target.challengeDescriptors.length) {
    return [];
  }
  const ids = target.challengeDescriptors.map(d => d.challengeId);
  if (target instanceof Event && target.backupChallengeConfig) {
    if (target.backupChallengeConfig.allBackups?.length) {
      ids.push(...target.backupChallengeConfig.allBackups.map(d => d.challengeId));
    }
  }
  const result = ids.reduce((acc, challengeId) => {
    if (challengeId) {
      acc.push(challengeId);
    }
    return acc;
  }, [] as string[]);
  return result;
};
